export class EnvironmentConfig {
  static readonly API_ENDPOINT_URL?: string =
    process.env.REACT_APP_BBC_API_ENDPOINT;
  static readonly FILE_UPLOAD_MAX_SIZE?: string = process.env.REACT_APP_FILE_UPLOAD_MAX_SIZE;
}
